import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Translate, { useI18n } from '@hydra/common/components/i18n';
import { Icon, SafeAnchor } from '@hydra/common/components';
import { CriteriumSkeleton } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

import getWooIndexLink from '@hydra/utils/getWooIndexLink';

const useStyles = makeStyles(theme => ({
  global: {
    marginBottom: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center'
  }
}));

export const CriteriumTrafficPopularitySection = ({
  globalRank,
  tldRank,
  tld
}: {
  globalRank: number | null
  tldRank: number | null
  tld: string | null
}) => {
  const { isPdf, variant } = useReviewContext();
  const { numeral } = useI18n();
  const classes = useStyles();
  return (
    <div>
      <div className={classes.global}>
        {
          variant === 'nocrit'
            ? <CriteriumSkeleton width='70%' />
            : (globalRank && globalRank > 0
                ? (
                  <>
                    <Icon type='hreflang' size='sm' />
                    &nbsp;
                    {
                      isPdf
                        ? (
                          <Translate
                            content='traffic_popularity_global_rank'
                            with={{ rank: numeral(globalRank) && numeral(globalRank).format() }}
                          />
                          )
                        : (
                          <SafeAnchor
                            href={getWooIndexLink()}
                            rel='nofollow noopener noreferrer'
                            target='_blank'
                          >
                            <Translate
                              content='traffic_popularity_global_rank'
                              with={{ rank: numeral(globalRank) && numeral(globalRank).format() }}
                            />
                          </SafeAnchor>
                          )
                    }
                  </>
                  )
                : <Translate component='div' content='traffic_popularity_global_rank_too_low' />)
        }
      </div>
      {
        variant === 'nocrit'
          ? <CriteriumSkeleton width='70%' />
          : (tldRank && tldRank > 0
              ? (
                <Translate
                  content='traffic_popularity_tld_rank'
                  with={{ rank: numeral(tldRank) && numeral(tldRank).format(), tld: tld || '' }}
                />
                )
              : <Translate component='div' content='traffic_popularity_tld_rank_too_low' />)
      }
    </div>
  );
};

export default CriteriumTrafficPopularitySection;
